const promoSlider = () => {
  const promo = document.querySelector('.promo');

  if (!promo) {
    return;
  }

  if (promo) {
    const createSlider = () => {
      const slider = new Swiper(promo.querySelector('.swiper-container'), {
        direction: 'vertical',
        scrollbar: {
          el: '.promo .swiper-scrollbar',
        },
        breakpoints: {
          320: {
            direction: 'horizontal',
          },
          768: {
            direction: 'vertical',
          },
        },
      });
    };

    createSlider();

    window.addEventListener('resize', createSlider);
  }
};

export {promoSlider};
